import { render, staticRenderFns } from "./Betanin.vue?vue&type=template&id=b2fc65b8&lang=pug&"
import script from "./Betanin.vue?vue&type=script&lang=js&"
export * from "./Betanin.vue?vue&type=script&lang=js&"
import style0 from "./Betanin.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports